// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3386":"f6f3a255","4021":"80be8082","4639":"5d5f1c5e","5167":"ff29f259","6133":"a476650d","7353":"08406975"}[chunkId] + ".chunk.css";
};